import React from "react";
import {Button, Form, Modal, Select, Space, message, DatePicker} from "antd";
import {connect} from "react-redux";
import {displayErrors} from "../../libs/utils";
import moment from 'moment';
import {
    adminCreateWebsiteSetupSharedHostingOrder,
    adminLoadAllInvoices,
    loadSharedHostingPlans
} from "../../actions/billing";

class WebsiteSetupSharedHostingOrderCreationModal extends React.Component {
    state = {
        loading: false,
        nextInvoiceDate: moment().add(1, 'year'),
        sharedHostingPlans: [],
        selectedSharedHostingPlan: null,
        loadingHostingPlans: false,
        hostingPlansLoaded: false,
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if(nextProps !== prevState) {
            return nextProps;
        }

        return null;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.showModal && !this.state.loadingHostingPlans && !this.state.hostingPlansLoaded) {
            this.setState({ loadingHostingPlans: true });

            this.props.loadSharedHostingPlans((res) => {
                this.setState({ loadingHostingPlans: false, hostingPlansLoaded: true, sharedHostingPlans: res.data.data });
            }, (err) => {
                if(typeof err.response !== 'undefined') {
                    this.setState({ loadingHostingPlans: false, hostingPlansLoaded: true });
                    displayErrors(err.response.data);
                }
            });
        }
    }

    closeModal(reload = false) {
        this.setState({
            loading: false,
            nextInvoiceDate: moment().add(1, 'year'),
            sharedHostingPlans: [],
            selectedSharedHostingPlan: null,
            loadingHostingPlans: false,
            hostingPlansLoaded: false,
        });

        this.props.close();

        if(reload) {
            this.props.reload();
        }
    }

    createOrder() {
        this.setState({ loading: true });

        let data = {
            next_invoice_date: this.state.nextInvoiceDate.format('YYYY-MM-DD'),
            shared_hosting_plan: this.state.selectedSharedHostingPlan,
            website_setup_order: this.props.orderId
        };

        this.props.adminCreateWebsiteSetupSharedHostingOrder(this.props.orderId, data, () => {
            this.closeModal(true);
            message.success('Shared hosting order successfully created!');
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                this.setState({ loading: false });
                displayErrors(err.response.data);
            }
        });
    }

    render() {
        const { Option } = Select;

        return(
            <Modal
                destroyOnClose={true}
                title='Create Shared Hosting Order'
                open={this.props.showModal}
                footer={<Space>
                    <Button disabled={this.state.loading} onClick={() => this.closeModal()}>Close</Button>
                    <Button disabled={this.state.loading} loading={this.state.loading} onClick={() => this.createOrder()} type='primary'>Create Order</Button>
                </Space>}
                onCancel={() => this.closeModal()}>
                <Form layout='vertical'>
                    <Form.Item label='Next invoice date'>
                        <DatePicker defaultValue={moment(this.state.nextInvoiceDate, 'YYYY-MM-DD')}
                                    format='YYYY-MM-DD'
                                    onChange={(e, _) => this.setState({ nextInvoiceDate: moment(_, ).format('YYYY-MM-DD') })} />
                    </Form.Item>
                    <Form.Item label='Shared hosting plan'>
                        <Select value={this.state.selectedSharedHostingPlan} onChange={(value) => this.setState({ selectedSharedHostingPlan: value })}>
                            {this.state.sharedHostingPlans.map((plan) => {
                                return <Option value={plan.guid}>{plan.name}</Option>;
                            })}
                        </Select>
                    </Form.Item>
                </Form>
            </Modal>
        )
    }
}

export default connect(null, { adminLoadAllInvoices, loadSharedHostingPlans,
    adminCreateWebsiteSetupSharedHostingOrder })(WebsiteSetupSharedHostingOrderCreationModal);